/**
 * Print Table function
 * this function must be called via `function.call`
 * @param {object} this the table component
 */
export default function printTable() {
  // this should be the table component (have a ref);
  // Cache the tableWrapper;
  const table = this.tableWrapper;
  const tableSize = this.tableWrapper
    .querySelector('#borderLayout_eRootPanel')
    .getBoundingClientRect();
  const tableHeight = tableSize.height;
  const tableWidth = tableSize.width;
  // Remove from dom
  this.tableWrapper.parentNode.removeChild(this.tableWrapper);
  // Now do maths
  const pageWidth = 700;
  const pageCount = Math.ceil(tableWidth / pageWidth);
  const printWrap = document.createElement('div');

  // Yes I'm using a for loop... it's the best thing to use here
  for (let i = 0; i < pageCount; i += 1) {
    const printPage = document.createElement('div');
    printPage.style.overflow = 'hidden';
    printPage.style.width = `${pageWidth}px`;
    printPage.style.height = `${tableHeight}px`;
    printPage['page-break-before'] = 0 === i ? 'auto' : 'always';
    printWrap.appendChild(printPage);
    const tableClone = table.cloneNode(true);
    tableClone.style.position = 'relative';
    tableClone.style.left = `${-(i * pageWidth)}px`;
    printPage.appendChild(tableClone);
    printWrap.appendChild(printPage);
  }

  // Attach printWrap to page
  document.querySelector('body').appendChild(printWrap);

  // Finally lets print
  if (window.onafterprint) {
    window.close();
  }

  // Timeout to let stuff finish printing
  window.setTimeout(() => {
    window.print();
  }, 200);
}



// WEBPACK FOOTER //
// ./app/services/printTable.js